module.exports = __webpack_public_path__ + "img/max-file-repeat--pdf.a1956a76.svg";